import parsePhoneNumberFromString from "libphonenumber-js";
import { isEmpty, isNil } from "lodash-es";

export type DialCode = {
  alpha2Code: string;
  callingCode: string;
};

export type PhoneNumberValue = DialCode & { number: string };

export const formatPhoneNumberForStorage = (value: PhoneNumberValue): string =>
  `+${value.callingCode} ${value.number}`.trim();

export const parseStoredPhoneNumber = (
  raw: string | undefined,
  countries: DialCode[],
): PhoneNumberValue | undefined => {
  if (isNil(raw)) {
    return undefined;
  }

  const trimmed = raw.trim();
  if (isEmpty(trimmed) || !trimmed.startsWith("+")) {
    return undefined;
  }

  const parsed = parsePhoneNumberFromString(trimmed);
  if (isNil(parsed)) {
    return undefined;
  }

  const callingCode = parsed.countryCallingCode;
  const number = trimmed.slice(1 + callingCode.length).trimStart();

  if (!isNil(parsed.country)) {
    return { alpha2Code: parsed.country, callingCode, number };
  }

  const fallbackCountry = countries.find((country) => country.callingCode === callingCode);
  if (isNil(fallbackCountry)) {
    return undefined;
  }

  return { alpha2Code: fallbackCountry.alpha2Code, callingCode, number };
};
